module.exports = __webpack_public_path__ + "img/battle_section3_item1.d69cba24.png";